<template>
  <div class="newmodal" ref="modal" :class="{visible: isVisible}" @click="hide">
    <div class="newmodal__body" @click.stop>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NewModal",
    data() {
      return {
        isVisible: false
      };
    },
    mounted() {
      let modal = this.$refs.modal;
      let parent = modal.parentNode;
      if (modal && parent) {
        parent.removeChild(modal);
        document.getElementById("app").appendChild(modal);
      }
    },
    methods: {
      show() {
        this.isVisible = true;
      },
      hide() {
        this.isVisible = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
.newmodal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
  &.visible {
    opacity: 1;
    pointer-events: all;
    .newmodal__body {
      top: 0;
    }
  }
}

.newmodal__body {
  background-color: white;
  padding: 32px;
  border-radius: 32px;
  top: -100px;
  position: relative;
  transition: top 0.3s ease-in-out;
}
</style>